import { render } from "./ProfileEditWorkplaces.vue?vue&type=template&id=4d48b9d2&scoped=true&ts=true"
import script from "./ProfileEditWorkplaces.vue?vue&type=script&lang=ts"
export * from "./ProfileEditWorkplaces.vue?vue&type=script&lang=ts"

import "./ProfileEditWorkplaces.vue?vue&type=style&index=0&id=4d48b9d2&scoped=true&lang=css"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d48b9d2"]])

export default __exports__